// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"Jitsi_modalWrapper__GKTI2","description":"Jitsi_description__2_rYI","css-1oc7v0j":"Jitsi_css-1oc7v0j__2FEQx"};